/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CategoriaCaricoCreateDTO
 */
export interface CategoriaCaricoCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof CategoriaCaricoCreateDTO
     */
    codice: string;
    /**
     * 
     * @type {string}
     * @memberof CategoriaCaricoCreateDTO
     */
    descrizione?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CategoriaCaricoCreateDTO
     */
    attivo?: boolean;
}

/**
 * Check if a given object implements the CategoriaCaricoCreateDTO interface.
 */
export function instanceOfCategoriaCaricoCreateDTO(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "codice" in value;

    return isInstance;
}

export function CategoriaCaricoCreateDTOFromJSON(json: any): CategoriaCaricoCreateDTO {
    return CategoriaCaricoCreateDTOFromJSONTyped(json, false);
}

export function CategoriaCaricoCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoriaCaricoCreateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'codice': json['codice'],
        'descrizione': !exists(json, 'descrizione') ? undefined : json['descrizione'],
        'attivo': !exists(json, 'attivo') ? undefined : json['attivo'],
    };
}

export function CategoriaCaricoCreateDTOToJSON(value?: CategoriaCaricoCreateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'codice': value.codice,
        'descrizione': value.descrizione,
        'attivo': value.attivo,
    };
}

